import { render, staticRenderFns } from "./sms-program.vue?vue&type=template&id=71385d99&scoped=true&lang=pug"
import script from "./sms-program.vue?vue&type=script&lang=js"
export * from "./sms-program.vue?vue&type=script&lang=js"
import style0 from "./sms-program.vue?vue&type=style&index=0&id=71385d99&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71385d99",
  null
  
)

export default component.exports